import httpClient from '@/lib/httpClient.js'
import { useQuery, useQueryClient } from '@tanstack/react-query'

export default function useGetTransactions({
  offset,
  numberOfPeriods,
  periodType,
} = {}) {
  const queryClient = useQueryClient()

  const fetchData = async () => {
    // const response = await httpClient.get('team/cash-flow/transactions', {
    //   params: {
    //     o: offset,
    //     c: numberOfPeriods,
    //     p: periodType,
    //   },
    // })

    const responseStream = await httpClient.get(
      '/team/cash-flow/transactions/stream',
      {
        params: {
          o: offset,
          c: numberOfPeriods,
          p: periodType,
        },
      },
    )

    const res = responseStream.data.data.flat() //.sort((a, b) => a.id - b.id)

    queryClient.setQueryDefaults(['latest-transactions'], {
      gcTime: Infinity,
    })

    queryClient.setQueryData(['latest-transactions'], res)

    queryClient.invalidateQueries({
      queryKey: ['transactions-cache'],
    })

    return res
  }

  return useQuery({
    queryKey: ['transactions', offset, numberOfPeriods, periodType],
    queryFn: fetchData,
    staleTime: Infinity,
  })
}
